import React from 'react'
import { AWS_S3_URL } from 'utils/constants'
import { IIcon } from '../../interface'

const FileUploaderIcon = ({
  disabled,
  errorMessage,
  isFileAccepted,
  isFileRejected
}: IIcon): React.ReactElement | null => {
  let imageSrc

  if (disabled) {
    imageSrc = `${AWS_S3_URL}/img/icons/file-disabled.svg`
  } else if (errorMessage || isFileRejected) {
    imageSrc = `${AWS_S3_URL}/img/icons/error.svg`
  } else if (isFileAccepted) {
    imageSrc = `${AWS_S3_URL}/img/icons/check.svg`
  } else {
    imageSrc = `${AWS_S3_URL}/img/icons/file.svg`
  }
  return <img src={imageSrc} alt='icon' className='image' />
}

export default FileUploaderIcon
